import axios from "axios";

export function getZoomJwtToken() {
  return axios.get(process.env.VUE_APP_API_URL + "Zoom/createzoomjwttoken");
}

export function createZoomMeeting(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Zoom/createzoommeeting", data.createZoomModel);
}

export function deleteZoomMeeting(meetingId) {
  const config = {
    params: {
      meetingId: meetingId,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "Zoom/deleteZoomMeeting", config);
}

//
export function getZoomMeetings() {
  return axios.get(process.env.VUE_APP_API_URL + "Zoom/usermeetings");
}

export function getMeetingDetails(meetingId) {
  const config = {
    params: {
      meetingId: meetingId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Zoom/meetingdetails", config);
}

export function getMeetingParticipants(meetingId) {
  const config = {
    params: {
      meetingId: meetingId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Zoom/meetingparticipants", config);
}

export function getPastMeetingDetails(meetingId) {
  const config = {
    params: {
      meetingId: meetingId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Zoom/pastmeetingdetails", config);
}
